<template>
  <div class="add-my-competence__form">
    <h3>
      {{
        !!model.competenceSet?.id
          ? 'Изменить компетенции'
          : 'Добавить компетенции'
      }}
    </h3>
    <p>Выберите компетенции из списка или добавьте свои.</p>
    <a-col class="form__competencies">
      <div v-if="errors.getError('id')" class="set_id_error">
        {{ errors.getError('id') }}
      </div>

      <competence-set
        :index="0"
        :competence-set="competenceSet"
        :competence-options="competenceOptions"
        :api-errors="apiErrors"
        :disabled="disabled"
        @update="updateCompetenceSet"
      />

      <a-row :align="'bottom'" justify="space-between" class="form__buttons">
        <a-col>
          <div class="buttons__delete" v-if="!disabled && competenceSet.id">
            <a @click="handleDelete"> Удалить </a>
          </div>
        </a-col>
        <a-col>
          <a-form-item class="buttons__save">
            <c-button-primary
              :loading="isLoading"
              :disabled="disabled"
              @click="onFinish"
            >
              Сохранить
            </c-button-primary>
          </a-form-item>
        </a-col>
      </a-row>
    </a-col>
  </div>
</template>

<script setup>
  import CButtonPrimary from '@/components/UI/CButtonPrimary';
  import CompetenceSet from '@/components/projects/management/Competencies/CompetenceSet.vue';
  import { useCompetenceOptions } from '@/composables/useCompetenceOptions';
  import { onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import ErrorsHandler from '@/components/form/errors-handler';
  import { useApi } from '@/api/use-api';

  const api = useApi();
  const route = useRoute();
  const { competenceOptions } = useCompetenceOptions(route.params.id);
  const emit = defineEmits(['close', 'update', 'subaction']);
  const isLoading = ref(false);
  const apiErrors = ref(null);
  const errors = new ErrorsHandler({
    id: '',
  });

  const props = defineProps({
    competenceSet: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const model = reactive({
    competenceSet: null,
  });

  onMounted(async () => {
    fillModel(props.competenceSet);
  });

  const fillModel = (competenceSet) => {
    if (!competenceSet) return;

    model.competenceSet = competenceSet;
  };

  const onFinish = async () => {
    isLoading.value = true;

    try {
      await api.projectCompetenceSet.save({
        id: model.competenceSet.id,
        projectId: route.params.id,
        competenceSubject: model.competenceSet.competenceSubject,
        competenceTechnology: model.competenceSet.competenceTechnology,
        competenceSkill: model.competenceSet.competenceSkill,
      });

      emit('close');
      emit('update');
    } catch (error) {
      apiErrors.value = error.errors;
      errors.handleApiErrors(error);
    } finally {
      isLoading.value = false;
    }
  };

  const updateCompetenceSet = (value) => {
    model.competenceSet = value.competenceSet;
  };

  const handleDelete = async () => {
    if (model.competenceSet.id) {
      emit('subaction');
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  :deep(.ant-input) {
    font-family: 'Nunito Sans', sans-serif;
    &[disabled] {
      color: $color-text-primary;
    }
  }
  :deep(.ant-picker-input > input) {
    &[disabled] {
      color: $color-text-primary;
    }
  }

  .add-my-competence__form {
    padding: 112px 17px 0 17px;

    h3 {
      font: 700 18px/26px 'Nunito Sans';
    }

    h2 {
      color: $color-bg-status-rework;
      font: 700 14px/20px 'Nunito Sans';
      margin-top: 30px;
    }

    p {
      margin-top: 30px;
    }

    .ant-form-item {
      margin-bottom: 14px;
    }

    .form {
      &__competencies {
        flex-direction: column;
        margin-top: 40px;
        min-height: 216px;
        height: 100%;

        .field__label {
          color: $color-text-secondary-1;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          margin-bottom: 8px;
        }

        .set_id_error {
          color: $color-text-accent-red;
          margin-bottom: 14px;
        }
      }

      &__buttons {
        margin-top: 50px;

        .buttons {
          &__delete {
            a {
              border-bottom: 1px solid;
              color: $color-text-accent-red;
              font: 400 14px/20px 'Nunito Sans';
              text-decoration: none;
            }
          }

          &__save {
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>
